import { createAsyncThunk } from '@reduxjs/toolkit';
import { notifyApiError } from 'api/apiUtils';
import userDetailsService from 'api/userDetailsService';
import * as authService from "../../../api/authService";

export const getUserDetails = createAsyncThunk(
    'auth/getUserDetails',
    async (_, { rejectWithValue, extra: { i18n } }) => {
      try {
        return await userDetailsService.getUserDetails();
      } catch (err) {
        notifyApiError(i18n, err);
        return rejectWithValue(err);
      }
    }
);

export const refreshSession = createAsyncThunk(
    'auth/refreshSession',
    async (_, { rejectWithValue, extra: { i18n } }) => {
      try {
        return await authService.refreshSession();
      } catch (err) {
        notifyApiError(i18n, err);
        return rejectWithValue(err);
      }
    }
);

export const logUserOutThunk = createAsyncThunk(
    'auth/logUserOutThunk',
    async (_, { rejectWithValue, extra: { i18n } }) => {
      try {
        const response = await authService.logUserOutRequest();
        if (response.ok) {
          window.location.href = response.url;
        } else {
          throw new Error('Failed to process logout');
        }
        return response;
      } catch (err) {
        notifyApiError(i18n, err);
        return rejectWithValue(err);
      }
    }
);
